module.exports = __webpack_public_path__ + "img/slider_2.b96ceb59.jpg";